let filter = {
	theme: "Theme",
	age: "Age",
	compartments: "No. of Compartments",
	sizeCapacity: "Size/Capacity (ml)",
	category: "Product Category",
	discount: "Discount",
};

function hideOptions(collection, options) {
	if (window.location.pathname === `/collections/${collection}`) {
		options.forEach((opt) => {
			$(`span.filter-label:contains(${opt})`).parent().parent().parent().hide();
		});
	}
}

hideOptions("back-to-school", [filter.compartments, filter.sizeCapacity, filter.discount]);
hideOptions("2022-collection", [filter.compartments, filter.sizeCapacity, filter.discount]);

// By Age
hideOptions("0-2-years", [filter.compartments, filter.sizeCapacity, filter.age, filter.discount]);
hideOptions("2-6-years", [filter.compartments, filter.sizeCapacity, filter.age, filter.discount]);
hideOptions("6-years", [filter.compartments, filter.sizeCapacity, filter.age, filter.discount]);

// By Product
hideOptions("teens-and-young-adults", [
	filter.compartments,
	filter.sizeCapacity,
	filter.age,
	filter.discount,
]);
hideOptions("snack-boxes", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("water-bottle", [filter.compartments, filter.category, filter.discount]);
hideOptions("bags-kids", [filter.compartments, filter.sizeCapacity, filter.discount]);
hideOptions("food-jars", [filter.compartments, filter.category, filter.discount]);
hideOptions("travel-mugs", [filter.compartments, filter.category, filter.discount]);
hideOptions("bamboo-tableware", [filter.compartments, filter.sizeCapacity, filter.discount]);
hideOptions("bio-based-tableware", [filter.compartments, filter.sizeCapacity, filter.discount]);
hideOptions("accessories", [filter.compartments, filter.sizeCapacity, filter.age, filter.discount]);

// By Theme
hideOptions("cherry", [filter.compartments, filter.sizeCapacity, filter.theme, filter.discount]);
hideOptions("dino", [filter.compartments, filter.sizeCapacity, filter.theme, filter.discount]);
hideOptions("leo", [filter.compartments, filter.sizeCapacity, filter.theme, filter.discount]);
hideOptions("lemon", [filter.compartments, filter.sizeCapacity, filter.theme, filter.discount]);
hideOptions("spaceship", [filter.compartments, filter.sizeCapacity, filter.theme, filter.discount]);
hideOptions("thunder", [filter.compartments, filter.sizeCapacity, filter.theme, filter.discount]);
hideOptions("unicorn", [filter.compartments, filter.sizeCapacity, filter.theme, filter.discount]);
hideOptions("plain-colors", [
	filter.compartments,
	filter.sizeCapacity,
	filter.theme,
	filter.discount,
]);

// By Gender
hideOptions("boys", [filter.compartments, filter.sizeCapacity, filter.discount]);
hideOptions("girls", [filter.compartments, filter.sizeCapacity, filter.discount]);
hideOptions("gender-neutral", [filter.compartments, filter.sizeCapacity, filter.discount]);

// By Sets
hideOptions("sets", [filter.compartments, filter.sizeCapacity, filter.category, filter.discount]);
hideOptions("unicorn-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("cherry-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("lemon-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("spaceship-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("dino-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("green-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("pink-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("purple-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("blue-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("yellow-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);
hideOptions("black-set", [
	filter.compartments,
	filter.sizeCapacity,
	filter.category,
	filter.discount,
]);

hideOptions("eco-friendly", [filter.compartments, filter.sizeCapacity, filter.discount]);
hideOptions("bamboo-toys", [filter.compartments, filter.sizeCapacity, filter.discount]);
hideOptions("gifts", [filter.compartments, filter.sizeCapacity, filter.discount]);
hideOptions("sale", [filter.compartments, filter.sizeCapacity]);
